
"use client"
import { Component } from "react";

import { RemoveCurrentPageDialog } from "./tools/removeCurrentPageDialog"
import { RemoveAllPagesDialog } from "./tools/removeAllPagesDialog"


export default class DWTEditBar extends Component {

  dlgRemoveCurrent;
  dlgRemoveAll;

  constructor(props) {
    super(props);

    this.dlgRemoveCurrent = new RemoveCurrentPageDialog(props.dwtUtil);
    this.dlgRemoveAll = new RemoveAllPagesDialog(props.dwtUtil);
  }

  clickbtnZoomOut() {
    this.props.dwtUtil.onclickZoomOut();
  }
  clickbtnZoomIn() {
    this.props.dwtUtil.onclickZoomIn();
  }
  clickbtnOrigSize() {
    this.props.dwtUtil.onclickOrigSize();
  }
  clickbtnFitWindow() {
    this.props.dwtUtil.onclickFitWindow();
  }
  clickbtnRotateLeft() {
    this.props.dwtUtil.onclickRotateLeft();
  }
  clickbtnCrop() {
    this.props.dwtUtil.onclickCrop();
  }
  clickbtnShowImageEditor() {
    this.props.dwtUtil.onclickShowImageEditor();
  }
  clickbtnSelect() {
    this.props.dwtUtil.onclickSelect();
  }
  clickbtnHand() {
    this.props.dwtUtil.onclickHandButton();
  }

  clickbtnRemoveCurrentImage() {
    this.dlgRemoveCurrent.remove();
  }
  clickbtnRemoveAllImages() {
    this.dlgRemoveAll.removeAll();
  }

  render() {
    return (
      <>
        <div id="divEdit">
          <ul class="operateGrp">
            <li>
              <div class="menuIcon RemoveSelectedImages" style={{ marginLeft: "5px" }} title="Remove current page"
                alt="Remove current page" id="DW_btnRemoveCurrentImage" onClick={(event) => this.clickbtnRemoveCurrentImage()} ></div>
            </li>
            <li>
              <div class="menuIcon RemoveAllImages" title="Remove all pages" alt="Remove all pages" id="DW_btnRemoveAllImages"
                onClick={(event) => this.clickbtnRemoveAllImages()}></div>
            </li>
            <li style={{ width:"90px" }} ></li>
            <li class="lblShowCurrentImage"><input type="text" size="2" id="DW_CurrentImage" readonly="readonly" />/<input
                type="text" size="2" id="DW_TotalImage" readonly="readonly" /></li>
            <li class="lblZoom">
              <ul>
                <li style={{ width:"25%" }}>
                  <div class="menuIcon ZoomOut" title="Zoom out" alt="Zoom out" id="btnZoomOut" onClick={(event) => this.clickbtnZoomOut()}>
                  </div>
                </li>
                <li style={{ width:"50%" }}><input type="text" id="DW_spanZoom" readonly="readonly" /></li>
                <li style={{ width:"25%" }}>
                  <div class="menuIcon ZoomIn" title="Zoom in" alt="Zoom in" id="btnZoomIn" onClick={(event) => this.clickbtnZoomIn()}>
                  </div>
                </li>
              </ul>
            </li>
            <li>
              <div style={{ marginLeft: "10px" }} class="menuIcon OrigSize" title="1:1" alt="1:1" id="btnOrigSize"
                onClick={(event) => this.clickbtnOrigSize()}></div>
              <div class="menuIcon FitWindow" title="Fit To Window" alt="Fit To Window" id="btnFitWindow" style={{ display:"none" }}
                onClick={(event) => this.clickbtnFitWindow()}></div>
            </li>
            <li style={{ width: "50px" }}></li>
            <li>
              <div class="menuIcon RotateLeft" title="Rotate left" alt="Rotate left" id="btnRotateL"
                onClick={(event) => this.clickbtnRotateLeft()}></div>
            </li>
            <li>
              <div class="menuIcon grayimg Crop" title="Please select an area to crop." alt="Please select an area to crop."
                id="btnCropGray"></div>
              <div class="menuIcon Crop" title="Crop" alt="Crop" id="btnCrop" style={{ display:"none" }} onClick={(event) => this.clickbtnCrop()}>
              </div>
            </li>
            <li>
              <div class="menuIcon ShowEditor" title="Show image editor" alt="Show image editor" id="btnShowImageEditor"
                onClick={(event) => this.clickbtnShowImageEditor()}></div>
            </li>
            <li style={{ marginTop: "0" }}>
              <div class="menuIcon SelectSelected" title="Select" alt="Select" id="btnSelect_selected"></div>
              <div class="menuIcon Select" style={{ display:"none" }} title="Select" alt="Select" id="btnSelect"
                onClick={(event) => this.clickbtnSelect()}></div>
            </li>
            <li style={{ marginTop: "0" }}>
              <div class="menuIcon HandSelected" style={{ display:"none" }} title="Hand" alt="Hand" id="btnHand_selected">
              </div>
              <div class="menuIcon Hand" title="Hand" alt="Hand" id="btnHand" onClick={(event) => this.clickbtnHand()}></div>
            </li>
          </ul>
        </div>
      </>
    );
  }
}
